<template>
  <div class="outside_show_box">
    <div class="inside_show_box">
      <div class="header_outside_box">
        <div class="header_inside_one">
          <div class="header_image_box">
            <img src="../assets/radishImg/logo.png" class="logo_image"/>
          </div>
          <div class="header_word_box">
            <span class="header_span_title">兼职萝卜</span>
            <span class="header_small_box">官网</span>
            <div class="image_start_box">
              <img src="../assets/index/star1.png" v-for="item in 4" :key="item" style="width: 1.3rem;height: 1.3rem"/>
              <img src="../assets/index/star2.png" style="width: 1.3rem;height: 1.3rem"/>
              <span class="image_start_span">4.9分</span>
            </div>
            <div>
              <p style="color: #999;font-size: 0.85rem;display: flex;align-items: center">251万下载 · 28.6M · 无广告</p>
              <p style="color: #999;font-size: 0.85rem;margin-left: 1rem;margin-top: -1.2rem;margin-left: 12rem;">分类： <span style="border:1px solid #999;padding: 0 0.4rem">生活</span></p>
            </div>
          </div>

        </div>
        <div class="header_btn_box">
          <button class="header_btn_class">安装到手机</button>
          <button class="header_btn_class">立即下载</button>
        </div>
      </div>
      <div class="middle_outside_box">
        <img src="../assets/radishImg/one.png" class="middle_image_style"/>
        <img src="../assets/radishImg/tow.png" class="middle_image_style"/>
        <img src="../assets/radishImg/three.png" class="middle_image_style"/>
        <img src="../assets/radishImg/four.png" class="middle_image_style"/>
        <p style="font-size: 1.25rem;font-weight: 600;padding: 0.5rem 0">应用信息</p>
        <!--        <p style="font-size: 0.85rem;padding: 0.5rem 0">手机兼职赚钱软件就选兼职糯米狗！</p>-->
        <p style="font-size: 0.85rem;padding: 0.5rem 0">找兼职就用兼职萝卜软件！兼职萝卜是一款在家就可以投简历的兼职App，空闲时间找短期兼职，轻松赚零花，丰富的兼职类型和海量岗位，都在兼职萝卜。</p>
      </div>
      <div class="bottom_outside_box">
        <span class="bottom_span_one">版权所有：上海燃聚网络科技有限公司</span>
        <span class="bottom_span_tow">备案号：</span>
        <a href="https://beian.miit.gov.cn" target="_blank" style="font-size: 0.85rem;color: #666">沪ICP备2020032468号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "radishRecruit"
}
</script>

<style scoped>
*{
  margin: 0;
  border:0;
  padding: 0;
}
.outside_show_box{
  width: 100%;
  height: 1065px;
  background-color: rgb(242,246,249);
}
.inside_show_box{
  width: 80%;
  height: 1065px;
  margin: 0 auto;
}
.header_outside_box{
  padding: 1.25rem;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
}
.header_inside_one{
  width: 60%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
}
.header_image_box{
  width: 7.5rem;
  height: 7.5rem;
  border:12px solid rgb(244,244,244);
  border-radius: 0.63rem;
}
.logo_image{
  width: 100%;
  height: 100%;
}
.header_word_box{
  width: 33%;
  height: 85%;
  margin-left: 1.25rem;
}
.header_span_title{
  font-size: 1.5rem;
  font-weight: 600;
}
.header_small_box{
  width: 1.6rem;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.8rem;
  border: 1px solid #267DEB;
  color: #267DEB;
  padding: 0 4px;
  margin-left: 0.8rem;
}
.image_start_box{
  padding: 1rem 0;
}
.image_start_span{
  font-size: 1.3rem;
  margin-left: 1rem;
}
.header_btn_box{
  width: 10%;
}
.header_btn_class{
  width: 9rem;
  height: 3rem;
  font-size: 1.25rem;
  color: white;
  background-color: rgb(240,115,33);
  margin: 0.5rem 0;
}
.middle_outside_box{
  width: 98.5%;
  height: auto;
  background-color: white;
  margin: 1rem 0;
  padding: 0.7rem;
}
.middle_image_style{
  width: 22.5%;
  height: 85%;
  padding: 0 0.8rem;
}
.bottom_outside_box{
  width: 100%;
  height: 5%;
  padding: 2rem;
}
.bottom_span_one{
  font-size: 0.85rem;
  margin-left: 30%;
  color: #666;
}
.bottom_span_tow {
  font-size: 0.85rem;
  margin-left: 3%;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/radishRecruit.vue